import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from './breadcrumb.component';
import { SharedModule } from '../../shared/shared.module';
import { RouterModule } from '@angular/router';
import { IconsModule } from '../../icons/icons.module';



@NgModule({
  declarations: [
    BreadcrumbComponent
  ],
  exports: [
    BreadcrumbComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    IconsModule
  ]
})
export class BreadcrumbModule { }
